<template>
    <div @click="state.isOpen = true" class="cursor-pointer" v-bind="$attrs">
        <slot></slot>
    </div>
    <ModalCustom
        :is-open="state.isOpen"
        @close="state.isOpen = false"
        title="Rename Video"
    >
        <form action="/video/rename" method="POST">
            <input type="hidden" name="_token" :value="$root.csrfToken" />
            <input type="hidden" name="id" :value="props.video.id" />
            <app-input
                name="title"
                placeholder="Video Title"
                v-model="state.title"
            ></app-input>
            <div class="flex mt-4 justify-end">
                <button
                    type="submit"
                    class="
                        rounded-full
                        bg-gradient-to-br
                        py-2
                        px-6
                        from-primaryLight
                        to-primary
                        text-white
                        p-1
                    "
                >
                    Save
                </button>
            </div>
        </form>
    </ModalCustom>
</template>

<script setup>
import { defineProps, reactive } from "vue";

const props = defineProps(["video"]);

const state = reactive({
    isOpen: false,
    title: props.video.title,
});
</script>
